var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTumblrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_30776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4,
    width: 26,
    height: 25,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1082 8.02388V24.6461C30.1082 26.0106 29.612 27.1891 28.6197 28.1814C27.6273 29.1738 26.4488 29.67 25.0843 29.67H8.52413C7.15962 29.67 5.98117 29.1738 4.9888 28.1814C3.99643 27.1891 3.50024 26.0106 3.50024 24.6461V8.02388C3.50024 6.65937 3.99643 5.48093 4.9888 4.48856C5.98117 3.49619 7.15962 3 8.52413 3H25.0843C26.4488 3 27.6273 3.49619 28.6197 4.48856C29.612 5.48093 30.1082 6.65937 30.1082 8.02388ZM23.1616 26.0727L22.1072 22.9095C21.611 23.1576 20.9908 23.2816 20.3085 23.2816C19.8744 23.2816 19.5643 23.2196 19.2542 23.0955C18.944 22.9715 18.758 22.7854 18.5719 22.5373C18.4478 22.2892 18.3238 22.1032 18.2618 21.8551C18.1998 21.607 18.1998 21.3589 18.1998 21.1108V14.2262H22.6034V10.877H18.1998V5.23284H14.9745C14.9125 5.23284 14.8505 5.29486 14.7885 5.41891C14.7265 5.91509 14.6024 6.41128 14.4784 6.90747C14.3543 7.40365 14.1062 7.96186 13.7961 8.58209C13.486 9.20233 13.0518 9.76054 12.4936 10.2567C11.9354 10.7529 11.2532 11.125 10.4468 11.4352V14.2882H12.6797V21.545C12.6797 22.2272 12.8037 22.8474 13.0518 23.5297C13.2999 24.212 13.6721 24.8322 14.1682 25.4524C14.6644 26.0727 15.3467 26.5688 16.277 26.941C17.1454 27.3131 18.1998 27.4992 19.3162 27.4992C20.1225 27.4992 20.9288 27.3131 21.6731 27.065C22.4794 26.6929 22.9755 26.3828 23.1616 26.0727Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_30776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblrIcon);
export default __webpack_public_path__ + "static/media/tumblr-icon.e2c6843ccba220b683951594085924d7.svg";
export { ForwardRef as ReactComponent };